import $ from "jquery";

$(() => {
    document.querySelectorAll<HTMLSelectElement>('.language-select select').forEach((select) => {
        // Navigation must only happen on an explicit user commit — never on a
        // stray `change` event fired by keyboard arrow keys while the list is
        // closed (Windows) or on blur-commit. Otherwise arrow-navigation past
        // the control immediately loads another language (WCAG 3.2.2 failure).
        let pointerSelecting = false;

        select.addEventListener('mousedown', () => { pointerSelecting = true; });
        select.addEventListener('touchstart', () => { pointerSelecting = true; }, { passive: true });

        select.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' && select.value) {
                event.preventDefault();
                window.location.href = select.value;
            }
        });

        select.addEventListener('change', () => {
            if (pointerSelecting && select.value) {
                window.location.href = select.value;
            }
            pointerSelecting = false;
        });

        select.addEventListener('blur', () => {
            pointerSelecting = false;
            // Reset the announced value so a keyboard user who arrow-scrolled
            // through options without committing isn't left with a misleading
            // "current selection" the next time the control receives focus.
            select.value = '';
        });
    });
});


